import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton as MUIIconButton,
  Tooltip as MUITooltip
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

// v5 shrank IconButton's own default padding (medium: 12px v4 -> 8px v5, small: 3px v4 ->
// 5px v5) — restored per-size here to keep every IconButton's hit-area unchanged (icon
// size itself is unaffected either way).
const sizePadding = { small: 3, medium: 12 };

const useStyles = makeStyles()((_theme, { style, size }) => ({
  root: ({
    padding: sizePadding[size] ?? sizePadding.medium,
    ...style
  })
}));

export const IconButton = props => {
  const {
    // eslint-disable-next-line id-length, no-unused-vars
    style: _,
    size = 'medium',
    tooltip = '',
    TooltipProps = {},
    ...data
  } = props;

  const { classes } = useStyles({ style: props.style, size });

  return (
    <MUITooltip title={tooltip} {...TooltipProps}>
      <MUIIconButton
        {...data}
        size={size}
        classes={{ root: classes.root, ...props.classes }}
      />
    </MUITooltip>
  );
};

IconButton.propTypes = {
  TooltipProps: PropTypes.object,
  classes: PropTypes.object,
  size: PropTypes.string,
  style: PropTypes.object,
  tooltip: PropTypes.string
};
